import React from 'react';
import TaskManagement from './TaskManagement';

const App = () => {

    return (
        <div>
            <TaskManagement />
        </div>
    );
};

export default App;
